// extracted by mini-css-extract-plugin
export default {"-large":"HwB2PPmJdh_ztbSMjctF","grid":"K_p55zD9Hqr6l5iZqg2Q","gridTopShadow":"N1M6Ie9Hg3OXpexAnBMt","gridBottomShadow":"XEEIraN2y_dwnO6fXZ7w"};